import type { ReactNode } from "react";

interface TagProps {
  /** highlighter-filled */
  hi?: boolean;
  /** record red */
  rec?: boolean;
  /** leading status dot in `color` */
  dot?: boolean;
  /** monospace meta */
  mono?: boolean;
  /** dot / text color (token var or css color) */
  color?: string;
  children?: ReactNode;
  className?: string;
}

export function Tag({ hi, rec, dot, mono, color, children, className }: TagProps) {
  const cls = ["tag", hi && "tag--hi", rec && "tag--rec", dot && "tag--dot", mono && "mono", className]
    .filter(Boolean)
    .join(" ");
  const style = color && !hi ? { color, borderColor: `color-mix(in srgb, ${color} 50%, transparent)` } : undefined;
  return (
    <span className={cls} style={style}>
      {children}
    </span>
  );
}
